var map = {
	"./buy_super_cn.png": "8270",
	"./buy_super_en.png": "6e73",
	"./buy_super_id.png": "7511",
	"./buy_super_ko.png": "2e51",
	"./buy_super_ph.png": "0b7d",
	"./buy_super_th.png": "5651",
	"./buy_super_zh.png": "9b08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f705";